import { UpdateUserQueryArg } from '../types/query-arg';
import { UpdateUserQueryBody } from '../types/query-body';

export const updateUserQueryBody = ({
  id,
  firstName,
  lastName,
  roleId,
  organisationId,
  permittedGroups,
}: UpdateUserQueryArg): UpdateUserQueryBody => ({
  id,
  firstName,
  lastName,
  roleId,
  permittedGroups,
  ...(organisationId ? { organisationId } : {}),
});
